__webpack_require__.p = "/New_Pokedex/";